<form #form="ngForm" novalidate (submit)="form.valid && onSubmit()" class="orgFormModal">
  <div class="modal-header">
    <h4 class="h4 modal-title">
      <span i18n>{{ title }}</span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body sm-bg-grey-1">
    <div class="form-group row">
      <label i18n for="name" class="default-label col-form-label col-sm-4">Name</label>
      <div [class.has-danger]="form.submitted && name.invalid" class="col-sm-8">
        <input
          type="text"
          placeholder="Type name"
          i18n-placeholder="Type name"
          class="form-control"
          name="name"
          id="name"
          required
          #name="ngModel"
          [(ngModel)]="model.name"
          ccFocus
          autocomplete="off"
          [pattern]="doNotAcceptWithoutAlphanumeric"
        />
        <div class="sm-text-default-red" i18n *ngIf="form.submitted && !model.name">name is required</div>
        <div class="sm-text-default-red" i18n *ngIf="form.submitted && name.errors?.pattern">
          Name should have one or more alphanumeric characters
        </div>
      </div>
    </div>
    <div class="form-group text-center pt-3">
      <button type="submit" class="btn btn-success" [ccBusyButton]="loading">Save</button>
    </div>
  </div>
</form>
